import CognitoAuth from './cognito'
import awsExports from '@/aws-exports'
import { Auth } from '@aws-amplify/auth'

Auth.configure(awsExports)

export default new CognitoAuth()
